import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { addDays, isWeekend } from 'date-fns';
import { i18n } from "@lingui/core";

const BookingDatePicker = ({ formData, setFormData }) => {
    const handleDateChange = (date) => {
        setFormData((prev) => ({
            ...prev,
            visitDate: date,
        }));
    };

    return (
        <div className="dp-input">
            <DatePicker
                selected={formData.visitDate}
                onChange={handleDateChange}
                minDate={addDays(new Date(), 1)}
                maxDate={addDays(new Date(), 30)}
                filterDate={(date) => !isWeekend(date)}
                placeholderText={i18n._("selectDate")}
                className="form-control"
                name="visitDate"
                required
                dateFormat="yyyy-MM-dd"
            />
        </div>
    );
};

export default BookingDatePicker;
